<template>
  <div id="quoteFour"></div>
</template>

<script>
export default {
  name: "QuoteFour",
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        quote:
          "Using LinkedIn without consistency is like *a ship without a compass*.",
        author: "John Doe",
        author_bio: "Author is a software engineer at Google",
      }),
    },
    scale: {
      type: Number,
      required: true,
      default: 0.8,
    },
  },
  computed: {
    workspace() {
      return this.$store.state.workspace;
    },
  },
  mounted() {
    this.render();
  },
  watch: {
    scale: {
      handler(newVal) {
        console.log("scale", newVal);
        this.render();
      },
      immediate: true,
      deep: true,
    },
    data: {
      handler() {
        this.render();
      },
      deep: true,
    },
  },
  methods: {
    render() {
      const quoteFour = document.getElementById("quoteFour");
      if (!quoteFour) return;
      quoteFour.innerHTML = this.exportHTML();
    },
    exportHTML(exporting = false) {
      const containerSize = exporting ? 1200 : 1200 * this.scale;
      const fontSize = exporting ? 54 : 54 * this.scale;
      const logoHeight = exporting ? 42 : 42 * this.scale;
      const authorSize = exporting ? 30 : 30 * this.scale;
      const bioSize = exporting ? 25 : 25 * this.scale;
      const chipSize = exporting ? 22 : 22 * this.scale;

      const logoSrc = this.workspace?.branding?.logo?.dark || "";

      let openingDiv = `<div style="height: ${containerSize}px; width: ${containerSize}px; aspect-ratio: 1 / 1;">`;

      let html = `
        ${openingDiv}
        <div
          style="
            background: linear-gradient(145deg, #fff5eb 0%, #ffecd2 25%, #fcb69f 50%, #ee9ca7 75%, #ffdde1 100%);
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            width: 100%;
            aspect-ratio: 1 / 1;
            position: relative;
            overflow: hidden;
          "
        >
          <!-- Noise texture overlay -->
          <div style="
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            opacity: 0.4;
            background-image: url('data:image/svg+xml,%3Csvg viewBox=%220 0 256 256%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cfilter id=%22noise%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.8%22 numOctaves=%224%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23noise)%22/%3E%3C/svg%3E');
            pointer-events: none;
          "></div>

          <!-- Header with logo -->
          <div style="padding: 10%; position: relative; z-index: 1;">
            <img
              src="${logoSrc}"
              height="${logoHeight}px"
              alt=""
            />
          </div>

          <!-- Quote content - centered -->
          <div style="
            padding: 0 10%;
            position: relative;
            z-index: 1;
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;
          ">
            <div style="
              font-size: ${fontSize}px;
              font-weight: 500;
              color: #3d2314;
              line-height: 1.4;
              letter-spacing: -0.01em;
              margin-bottom: 48px;
            ">"${this.data.quote.replace(
              /\*([^*]+)\*/g,
              '<span class="template-libre">$1</span>'
            )}"</div>

            <div style="text-align: center;">
              <p style="
                color: #3d2314;
                font-size: ${authorSize}px;
                margin: 0;
                font-weight: 700;
                font-family: 'Inter', 'Helvetica Neue', sans-serif;
              ">
                ${this.data.author}
              </p>
              <p style="
                color: #6b4423;
                font-size: ${bioSize}px;
                margin: 8px 0 0 0;
                font-weight: 400;
                font-family: 'Inter', 'Helvetica Neue', sans-serif;
                opacity: 0.8;
              ">${this.data.author_bio}</p>
            </div>
          </div>

          <!-- Footer with chip -->
          <div style="padding: 10%; position: relative; z-index: 1; display: flex; justify-content: center;">
            <span
              style="
                display: inline-block;
                background: rgba(255, 255, 255, 0.6);
                backdrop-filter: blur(8px);
                color: #3d2314;
                font-size: ${chipSize}px;
                font-weight: 600;
                border-radius: 999px;
                padding: 14px 28px;
                letter-spacing: 0.02em;
                font-family: 'Inter', 'Helvetica Neue', sans-serif;
                box-shadow: 0 4px 20px rgba(61, 35, 20, 0.1);
              "
            >
              ${this.data.chip}
            </span>
          </div>
        </div>
      </div>
      `;

      return html;
    },
  },
};
</script>

<style>
.template-libre {
  font-family: "Libre Baskerville", serif;
  font-weight: 500;
  font-style: italic;
}
</style>
